<template>
    <v-expansion-panel focusable  popout @click.once="getInvestigatorGrants">
        <v-expansion-panel-header  :class="{xsclass:xsOnly, lgclass:!xsOnly}"  >
            {{ $t("production.grants")}}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mp-0">
            <v-btn outlined  color="indigo" :class="{active:isActive, noactive:!isActive}" @click="getRunningGrants" >{{ $t("buttongrants.1")}}</v-btn>
            <v-btn outlined  color="indigo" :class="{active:!isActive, noactive:isActive}" @click="getPastGrants">{{ $t("buttongrants.0")}}</v-btn>
            <v-card>
                <v-row class="mx-1 mt-1 pa-0">
                    <v-col class="d-flex my-0 py-1" cols="12" v-for="(item, index, key) in grants" :key="index" >
                        <v-card width="100%" flat class=" px-1 mx-0 mt-4 py-0" :key="index">
                            <app-grant-title :showTitle="true"  :item="item" ></app-grant-title>
                            <app-grant-description v-if="item"  class="my-0 py-0 mr-1"
                                :key="key" :grant="item" >
                            </app-grant-description>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>

import grantTitle from '../../grants/GrantTitle.vue';
import grantDescription from '../../grants/GrantDescription.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
  props:['id'],
  data(){
    return {
        isActive:true,
        /**
         * active: 0 for past grants, 1 for running grants
         */
        active:1,
        id_grant:null,
        grant_one:null,
    };
  },
  components:{
    appGrantDescription:grantDescription,
    appGrantTitle:grantTitle,
  },
  computed:{
    ...mapGetters('header',{
        xsOnly:'xsOnly',
    }),
    ...mapGetters('grants',{
        grants:'grants',
    }),
  },
  methods:{
    ...mapActions('grants',{
        setInvestigatorGrants:'setInvestigatorGrants',
    }),
    getInvestigatorGrants(){
            this.setInvestigatorGrants([this.active,this.id]);
    },
    getRunningGrants(){
        this.active = 1;
        this.isActive = true;
        this.setInvestigatorGrants([this.active,this.id]);
    },
    getPastGrants(){
       this.active = 0;
       this.isActive = false;
       this.setInvestigatorGrants([this.active,this.id]);
    },
  }
}
</script>
<style  scoped>
.active {
    background-color: #C5CAE9 !important;
}
.noactive {
    background-color: #FFFFFF !important;
}
.xsclass{
    width: 100%;
}
.lgclass{
    width: 8%;
}

</style>
